<template>
  <div :style="[windowWidth <= PHONE ? 'border-top: 8px solid #EFF4F7' : 'margin-bottom: 12px;']">
    <div :class="['bd-1 bd-gray-300-new', windowWidth > PHONE ? 'br-6' : '']">
      <div class='px-20 py-12 bd-b-1 bd-gray-300-new'>
        <div class='fs-18 fw-700 lh-24 flex items-center'>
          <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="4" height="16" rx="2" fill="#2179FF"/>
          </svg>
          <span class='pl-8'>{{props.title}}</span>
        </div>
        <div class='fs-14 lh-28 gray-800'>{{props.subTitle}}</div>
      </div>
      <div class='px-20 pt-8 pb-10'>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {computed} from 'vue'
  import {PHONE} from '~/constant/common'
  import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

  const props = defineProps({
    title: { type: String, default: '' },
    subTitle: { type: String, default: '' }
  })

  const generalStore = useGeneralInfoStore()

  const windowWidth = computed(() => generalStore.generalData.windowWidth)

</script>

<style scoped lang="scss">

</style>
